module.exports = __webpack_public_path__ + "media/images/service/n_8-62668596f81685a1764dcdfd41bd130a.jpg";